module.exports = __webpack_public_path__ + "static/img/concierge_back.28e163c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/concierge_back.png
// module id = j67s
// module chunks = 1